import React from 'react'
import styled from 'styled-components'

import Message from './Message'

const GoodMessage = (props) => {
  const {
    size,
    text,
  } = props

  const msg = (<h3>{text}</h3>)
  return (
    <Section>
      <Message
        size={size}
        icon="far fa-smile-beam"
        text={msg} />
    </Section>
  )
}

const Section = styled.div`
  text-align: center;
`

export default GoodMessage
